// Central obfuscated route map. Keeping paths in one module (a) avoids scattering
// guessable strings across the bundle and (b) makes the whole hierarchy swappable.
export const R = {
  login: '/',
  hub: '/pages/hub',
  reminders: '/pages/r3m1nd3rs',
  adminOps: '/pages/adm1n-m@n@g3r',
  proposalsHub: '/pages/pr0p0s@l-hub',
  commissionsHub: '/pages/c0mm1ss10n-hub',
  systems: '/pages/sy$tem$',
  systemsUserManager: '/pages/sy$tem$/u$er-m@n@ger',
  systemsGeoFence: '/pages/sy$tem$/ge0-fence',
  systemsAudit: '/pages/sy$tem$/aud1t-l0g$',
  overview: '/pages/0verv1ew',
  customers: '/pages/cu$tomer',
  customer: (id) => `/pages/cu$tomer/${id}`,
  eoiHub: '/pages/e0i-hub',
  eoiPunch: '/pages/e0i-hub/punch',
  bookings: '/pages/b00k1ng',
  migrateBooking: '/pages/b00k1ng-m1gr@t3',
  legacyMigration: '/pages/l3g@cy-m1gr@t10n',
  legacyArchive: '/pages/b00k1ng/l3g@cy',
  booking: (id) => `/pages/b00k1ng/${id}`,
  accounts: '/pages/acc0unt$',
  recentPayments: '/pages/acc0unt$/r3c3nt-p@ym3nt$',
  legal: '/pages/l3g@l',
  legalCalendar: '/pages/l3g@l-c@l3nd@r',
  loan: '/pages/l0@n-tr@ck',
  pricingTracker: '/pages/pr1c1ng-tr@ck3r',
  inventory: '/pages/1nv3nt0ry',
  recovery: '/pages/r3c0v3ry',
  reports: '/pages/r3p0rt$',
};

// Guessable defaults that scanners probe. Hitting any of these logs a security
// event, invalidates the session, and dead-ends in a generic 404.
export const HONEYPOTS = [
  '/admin', '/administrator', '/customer', '/dashboard', '/login', '/crm',
  '/wp-admin', '/panel', '/console',
  '/pages/admin', '/pages/administrator', '/pages/customer', '/pages/dashboard',
  '/pages/login', '/pages/booking', '/pages/accounts', '/pages/legal',
  '/pages/loan', '/pages/crm',
];
